<template>
    <RegistrationStepPage
        :key="currentSubPageKey"
        :step-name="currentSubPageKey">
        <QuestionMain
            v-model="answers"
            :registrar-mode="false"
            :questions="currentQuestions" />
    </RegistrationStepPage>
</template>

<script>
import QuestionMain from "@/components/pages/registration/questions/QuestionMain";
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";
import RegistrationStepPage from '@/components/farbcode-core/Registration/RegistrationStepPage'

const PARENT = 'participantsDetails'

export default {
    name: "ParticipantsDetails",
    components: {QuestionMain, RegistrationStepPage},
    mixins: [mainRegistrationMixin],
    computed: {
        subPages() {
            return this.$store.getters['registration/getParticipantSubPages']
        },
        visibleSubPages() {
            return this.subPages.filter(subPage => !subPage.hidden)
        },
        activeSubIndex() {
            const raw = this.$store.state.registration.activeSubPage[PARENT] ?? 0
            return Math.min(Math.max(raw, 0), Math.max(this.visibleSubPages.length - 1, 0))
        },
        currentSubPage() {
            return this.visibleSubPages[this.activeSubIndex]
        },
        currentSubPageKey() {
            return `${PARENT}#${this.currentSubPage?.index ?? 0}`
        },
        currentQuestions() {
            return this.currentSubPage?.questions ?? []
        },
        answers: {
            get: function () {
                return this.registrationData.answers
            },
            set: function (value) {
                this.setRegistrationProp('answers', value)
            }
        }
    }
}
</script>

<style scoped>

</style>
